import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const _GetNewHiresRequestDtoSchema = z.object({
  from: z.string(),
  to: z.string(),
  facilitiesIds: z.array(z.number()).optional(),
});

const GetNewHiresResponseDtoSchema = z.object({
  count: z.number(),
  changePct: z.number().nullable(),
});

export type GetNewHiresRequestDto = z.infer<
  typeof _GetNewHiresRequestDtoSchema
>;
export type GetNewHiresResponseDto = z.infer<
  typeof GetNewHiresResponseDtoSchema
>;

export const getNewHires = (
  params: GetNewHiresRequestDto,
  config?: AxiosRequestConfig<GetNewHiresRequestDto>
) => {
  return api
    .get('/staff/new-hires', { params, ...config })
    .then(responseContract(GetNewHiresResponseDtoSchema));
};
